import React, {useEffect, useRef} from 'react'
import {useTranslation} from 'react-i18next'
import QRCodeStyling from 'qr-code-styling'
import {Typography} from 'antd'
import {observer} from 'mobx-react'
import {colors} from '@/constants/theme/colors'
import {PaymentLinkQrProps} from './props'

import styles from './styles.scss'

export const PaymentLinkQr = observer(({url}: PaymentLinkQrProps) => {
    const {t} = useTranslation()
    const ref = useRef<HTMLDivElement | null>(null)
    const qrCode = useRef<QRCodeStyling | null>(null)

    useEffect(() => {
        qrCode.current = new QRCodeStyling({
            type: 'canvas',
            shape: 'square',
            width: 200,
            height: 200,
            data: url,
            margin: 0,
            qrOptions: {
                mode: 'Byte',
                errorCorrectionLevel: 'Q'
            },
            imageOptions: {
                saveAsBlob: true,
                hideBackgroundDots: false,
                imageSize: 0.4,
                margin: 0
            },
            dotsOptions: {type: 'rounded', color: colors.black, roundSize: true},
            backgroundOptions: {color: colors.white},
            cornersSquareOptions: {type: 'extra-rounded', color: colors.black}
        })

        if (ref.current) qrCode.current.append(ref.current)
    }, [])

    useEffect(() => {
        if (qrCode.current) {
            qrCode.current.update({data: url})
        }
    }, [url])

    return (
        <div className={styles.root}>
            <div ref={ref} />
            <Typography.Title className={styles.title} level={5}>
                {t('PaymentLinkDownloadPdfButton.scanToPay')}
            </Typography.Title>
        </div>
    )
})
